import { FC } from 'react';

import IconType from '../../../types/Icon';

const DeclinedIcon: FC<IconType> = ({ color = 'currentColor', size = 64 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14 8.76562V24H6V52H32.5312C34.3212 58.8778 40.5821 64 48 64C56.8 64 64 56.8 64 48C64 42.9772 61.6499 38.482 58 35.543V24H50V8.76562L44 11.7656L40 9.76562L36 11.7656L32 9.76562L28 11.7656L24 9.76562L20 11.7656L14 8.76562ZM24 14.2344L28 16.2344L32 14.2344L36 16.2344L40 14.2344L44 16.2344L46 15.2344V32H18V15.2344L20 16.2344L24 14.2344ZM10 28H14V36H37.4688C34.1273 38.938 32 43.228 32 48H10V28ZM50 28H54V33.1836C52.7377 32.6682 51.3961 32.3172 50 32.1406V28ZM48 36C54.6 36 60 41.4 60 48C60 54.6 54.6 60 48 60C41.4 60 36 54.6 36 48C36 41.4 41.4 36 48 36ZM18 40V44H22V40H18ZM26 40V44H30V40H26ZM43.3984 40.6016L40.6016 43.3984L45.1992 48L40.6016 52.6016L43.3984 55.3984L48 50.8008L52.6016 55.3984L55.3984 52.6016L50.8008 48L55.3984 43.3984L52.6016 40.6016L48 45.1992L43.3984 40.6016Z"
				fill={color}
			/>
		</svg>
	);
};

export default DeclinedIcon;
